export async function pathToFile(webPath, fileName = "photo.jpg") {
  const res = await fetch(webPath);
  const blob = await res.blob();
  return new File([blob], fileName, { type: blob.type || "image/jpeg" });
}
